import api from '@api';
import { call, put, takeEvery } from 'redux-saga/effects';
import { getRolesApprovedFetchSuccess, getRolesApprovedFetchFailure } from './reducer';
import { RolesApprovedResType } from 'src/types/rolesApproved';

const getRolesApprovedFetchRequest = async () => {
    const res = await api('get', 'api/secure/roles/approved');
    return res.data.data;
};

function* getRolesApprovedFetch(action: { type: string }) {
    try {
        const response: RolesApprovedResType = yield call((): any => getRolesApprovedFetchRequest());
        yield put(getRolesApprovedFetchSuccess(response));
    } catch (error) {
        yield put(getRolesApprovedFetchFailure({ error }));
    }
}

export function* getRolesApprovedFetchWatch() {
    yield takeEvery('rolesApproved/getRolesApprovedFetch', getRolesApprovedFetch);
}
